import { render, staticRenderFns } from "./BookingServicePackagesListTable.vue?vue&type=template&id=cf0c22de"
import script from "./BookingServicePackagesListTable.js?vue&type=script&lang=js&external"
export * from "./BookingServicePackagesListTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports